import {
    COLLECT_TRAVEL_INSURANCE_QUOTE_FORM_DATA,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    UPDATE_TRAVEL_INSURANCE_QUOTE_FORM_DATA,
} from '../../../actions/travelKe/quote';

import {
    TRIGGER_KE_PAYMENTS_STK_PUSH,
    CHECK_PAYMENTS_STATUS,
    TRIGGER_BANK_DETAILS,
    TRIGGER_MPESA_CONFIRMATION,
} from '../../../actions/travelKe/payments';
import { mpesaConfirmationService, paymentsStkService, paymentsStkStatusService } from './payments';
import { bankDetailsService } from './orderConfirmation';

import { premiumCalculationService, premiumCalculcationUpdateService } from './premiumCalculation';

import { COLLECT_PAYLOAD_DATA } from '../../../actions/travelKe/payloadCollection';
import { payloadSubmitService } from './payloadCollection';
import { shareQuoteService } from './shareQuote';
import { COLLECT_LOGIN_DETAILS } from '../../../actions/travelKe/auth';
import { loginService } from './login';

import { TRIGGER_FETCH_ALL_COUNTRIES, TRIGGER_FETCH_BENEFITS_EUROPE } from '../../../actions/travelKe/quote';
import { getCountriesService } from './products';
import { getBenefitsService } from './benefits';

import { TRIGGER_FETCH_AGENTS } from '../../../actions/travelKe/motorAgentModal';
import { getAgentsService } from './agents';

import {
    INITIATE_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
    PAYSTACK_SUBMIT_PAYMENT,
} from '../../../actions/travelKe/paystack';
import { paystackPaymentService, paystackStkStatusService, submitPaymentService } from './paystack';

export const travelKeServices = (store, next, action) => {
    if (action.type.startsWith(INITIATE_PAYMENT)) {
        return paystackPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS)) {
        return paystackStkStatusService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT)) {
        return submitPaymentService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_FETCH_ALL_COUNTRIES)) {
        return getCountriesService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_FETCH_BENEFITS_EUROPE)) {
        return getBenefitsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_MPESA_CONFIRMATION)) {
        return mpesaConfirmationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_KE_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_FETCH_AGENTS)) {
        return getAgentsService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_TRAVEL_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }
    if (action.type.startsWith(UPDATE_TRAVEL_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculcationUpdateService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_BANK_DETAILS)) {
        return bankDetailsService(store, next, action);
    }

    return null;
};
